/**
 * @module registration/creative/components/substep2_3
 */

import React, { Component, PropTypes } from 'react';
import values from 'lodash/values';
import AnimatedButton from 'common/components/animated_button';
import WorkSamples from 'registration/creative/containers/work_samples';
import Avatar from 'registration/creative/containers/avatar';
import { trackGoogle } from 'common/tracking';

/**
 * Substep 2.3 of creative registration.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
class Substep2_3 extends Component {
  constructor(props) {
    super(props)
    this.isNextDisabled = this.isNextDisabled.bind(this)
  }

  componentDidMount() {
    const { registrationSubmittedAt, idValidated, nextSubstep } = this.props;

    trackGoogle("registration", "uploaded documents", "creative");

    if (registrationSubmittedAt && !idValidated) {
      nextSubstep();
    }
  }

  isNextDisabled() {
    const {user, workSamples, avatar} = this.props
    /* filter active work categories */
    const samples = values(workSamples).filter((s) => (
      (typeof(s) == 'object' && Object.keys(s).length > 0) || s
    ))

    return (
      /* avatar was not successfully updated... */
      !avatar || user.error ||
      /* or no category has been selected */
      samples.length == 0
    )
  }

  render() {
    const { registrationSubmittedAt, registrationReopenedAt, avatar } = this.props;
    const hideAvatar = !!avatar && (registrationSubmittedAt || registrationReopenedAt);

    return (
      <div className="row align-center substep2-3">
        <div className="columns small-16 medium-12 large-10">
          <div className="step-header">
            <h2>Demonstrate Your Skills</h2>
            <p className="step-instructions">
              <strong>Before you can participate in any projects on crowdspring</strong>,
              you must { hideAvatar? "" : "upload a profile image and" } submit
              samples of your best work for each category of projects in which you intend
              to participate.
            </p>
          </div>

          <Avatar hide={!!hideAvatar} />

          <WorkSamples />

          <AnimatedButton label="Next" baseBtnClass="btn-tertiary btn-block"
            onClick={this.props.nextSubstep} disabled={this.isNextDisabled()} />
        </div>
      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {object} user - logged in user
 * @property {func} nextSubstep - move on to next substep
 * @property {object} workSamples - work samples for selected categories
 * @property {string} avatar - user's avatar
 *
 */
Substep2_3.propTypes = {
  user: PropTypes.object,
  nextSubstep: PropTypes.func,
  workSamples: PropTypes.object,
  avatar: PropTypes.string
};

export default Substep2_3;



// WEBPACK FOOTER //
// ./registration/creative/components/substep2_3.jsx